export const SET_QUERY_TYPE = 'SET_QUERY_TYPE';
export const SET_QUERY_PAGE = 'SET_QUERY_PAGE';
export const SET_QUERY_SORT_FIELD = 'SET_QUERY_SORT_FIELD';
export const SET_QUERY_SORT_ORDER = 'SET_QUERY_SORT_ORDER';
export const SET_QUERY_SEARCH = 'SET_QUERY_SEARCH';
export const CLEAR_QUERY_SEARCH = 'CLEAR_QUERY_SEARCH'
export const SET_QUERY_SEARCH_FIELD = 'SET_QUERY_SEARCH_FIELD';
export const RESET_QUERY = 'RESET_QUERY';
//not currently in use
export const SET_QUERY_LIMIT = 'SET_QUERY_LIMIT';